export const generationDefault = {
  "product_identity": "",
  "product_title": null,
  "user_question_counts": 0,
  "user_question_summary": null,
  "user_question_labels": null,
  "messages": []
}

export const PROTUCT_TYPE = {
  SELECT: 'selectProductList',
  CUSTOM: 'customProduct'
}

export const GENERATION_FORM_ERROR_MSG = {
  selectProduct: '從商品列表中選擇商品',
  generationProductTitle: '輸入商品描述',
  objectiveType: '選擇文案類型',
  objectiveCustom: '輸入自定義文案類型',
}

export const DEFAULT_INPUT_MESSAGE = "請推薦一些撰寫文案的想法，同時給我一些完整的範例";
export const EMPTY_BOX_MESSAGE = "輸入您的需求，跟 AI 一起發想文案！";
export const LOADING_MSG = "資料讀取中，請稍後...";
export const CUSTOM_IDENTITY = "27bd29228a1311efbc1042004e494300";

export const validateForm = (productType, generationForm) => {
  const newErrorMsg = {
    selectProduct: false,
    generationProductTitle: false,
    objectiveType: false,
    objectiveCustom: false,
  };
  let hasError = false;

  const isEmpty = (value) => value === null || value === "" || value === undefined;

  if (productType === PROTUCT_TYPE.SELECT && isEmpty(generationForm.product_title)) {
    newErrorMsg.selectProduct = true;
    hasError = true;
  }

  if (productType === PROTUCT_TYPE.CUSTOM && isEmpty(generationForm.generation_product_title)) {
    newErrorMsg.generationProductTitle = true;
    hasError = true;
  }

  if (isEmpty(generationForm.generation_text_objective_type)) {
    newErrorMsg.objectiveType = true;
    hasError = true;
  }

  if (generationForm.generation_text_objective_type === 'CUSTOM' && isEmpty(generationForm.generation_text_objective_custom)) {
    newErrorMsg.objectiveCustom = true;
    hasError = true;
  }

  return { newErrorMsg, isValid: !hasError };
};